/**
 * Generates a submission ID of the format `MIT-WPU/DocSub/{YY}/{00001}`
 * @param {Object} doc An Object containing all fields of the document
 * @returns {String} The submission ID
 */
export const generateSubmissionID = doc => {
  if (!(doc.submissionTimestamp && doc.submissionID)) {
    return "N/A";
  }
  const yearCode = doc.submissionTimestamp.toDate().getFullYear() % 100;
  const IDCode = doc.submissionID.toString().padStart(5, '0');
  return `MIT-WPU/DocSub/${yearCode}/${IDCode}`;
}
